export default {
  SET_ITEMS: (state, payload) => {
    state.items = payload;
  },
  SET_ITEM_BUNDLE: (state, payload) => {
    state.itemBundle = payload;
  }
}
